import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'dateFormatPipe',
})
export class dateFormatPipe implements PipeTransform {
  transform(value: string) {
    const datePipe = new DatePipe('en-US');
    //EEEE d MMMM hh:mm
    //value = datePipe.transform(value, 'MMM-dd-yyyy');
    const month = datePipe.transform(value, 'MMM');
    const longDay = datePipe.transform(value, 'EE');
    const day = datePipe.transform(value, 'd');
    const time = datePipe.transform(value, 'hh:mm');
    return longDay + ' ' + day + this.nth(Number(day)) + ' ' + month + ' ' + time;
  }

  nth(d: number): string {
    if (d > 3 && d < 21) return 'th';
    switch (d % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  }
}
